import { tokens } from "../../../theme";
import { Checkbox, Stack, Typography, useTheme } from "@mui/material";

const contentTextStyle = (colors) => ({
  margin: 0,
  font: "400 15px/1.55 system-ui",
  color: colors.ctlInk,
  "& strong": { fontWeight: 600, color: colors.ctlInkHover },
});

const WakeupDialogContent = ({ env, setRefreshDialog, setDialog }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  return (
    <>
      <Typography component="p" sx={contentTextStyle(colors)}>
        You are going to wake up the environment <strong>{env?.name}</strong>
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1} mt={1.5}>
        <Typography component="span" sx={contentTextStyle(colors)}>
          Auto Refresh on wake up
        </Typography>
        <Checkbox
          color="secondary"
          size="small"
          onChange={(e) => {
            setRefreshDialog({
              selectedEnv: env,
              isOpen: true,
            });
            setDialog({});
          }}
        />
      </Stack>
    </>
  );
};

export default WakeupDialogContent;
